import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

var cargadorCatalogosPacientes = null

const store = {
  state: {
    listaEspacios: {},
  },
  getters: {
    listaEspacios: state => {
      return state.listaEspacios
    },
  },
  mutations: {
    ASIGNA_CATALOGO_ESPACIOS(state, listaEspacios) {
      state.listaEspacios = listaEspacios
    },
  },
  actions: {
    // comentado por marco por que existen dos de este metodo y todo se junta en el index actualizarCaso({}, caso) {
    //   caso.fecha = new Date()
    //   return db
    //     .collection(FS_COLLECTIONS.CASOS)
    //     .doc(caso.id)
    //     .update(caso)
    // },
    agregarEspacio({ getters }, espacio) {
      var idFranquicia = getters.usuario.id_franquicia
      
      //console.log("ESPACIO DESDE STORE")
      //console.log(espacio.length)
      let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(idFranquicia)
          .collection(FS_COLLECTIONS.CATALOGOS)
          .doc(FS_COLLECTIONS.ESPACIOS)
      return docPath.set(espacio)
    },
    cargaEspacios({ commit, getters }) {
      return new Promise((resolve, reject) => {
        if (cargadorCatalogosPacientes === null) {

          var idFranquicia = getters.usuario.id_franquicia
        
            let docPath = db
              .collection(FS_COLLECTIONS.FRANQUICIAS)
              .doc(idFranquicia)
              .collection(FS_COLLECTIONS.CATALOGOS)
              .doc(FS_COLLECTIONS.ESPACIOS)
            cargadorCatalogosPacientes = docPath.onSnapshot(doc => {
              //console.log('Current data espacios: ', doc.data())
              commit('ASIGNA_CATALOGO_ESPACIOS', doc.data())
              resolve()
            })
        
        } else {
          resolve()
        }
      })
    },
    actualizarServicioCaso({getters}, servicio_caso) {
      return db
        .collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(getters.franquicia.id)
        .collection("ServiciosCasos")
        .doc(servicio_caso.id_caso_seleccionado)
        .update(servicio_caso.data);
    },
    guardaServicioCaso({getters},data){
      return new Promise((resolve, reject) => {
          db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id).collection("ServiciosCasos")
            .add(data)
            .then(docRefServicio => {
              resolve(docRefServicio)
            })
            .catch(error => {
              reject(error)
            })
        })
    },
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/espacios/espacios.js